import { createFileRoute } from '@tanstack/react-router'

import { DirectoryRouteKernel } from '~/features/football-entities/route-modules'
import { directoryRouteModule } from '~/features/football-entities/route-options'

export const Route = createFileRoute('/$locale/_public/teams-players')({
  ...directoryRouteModule,
  component: DirectoryRoute,
})

function DirectoryRoute() {
  return <DirectoryRouteKernel route={Route} />
}
